<div class="p-2">
  <!-- Title -->
  <div class="row pb-2">
    <div class="col-10 h5 text-muted p-0">Loyalty</div>
    <div class="col-2 p-0">
      <button type="button" class="btn btn-secondary btn-sm text-white float-end fw-bold" title="Back" (click)="onSettingsClick()">
        <i-bs class="text-light" name="sliders" width="20" height="20"></i-bs>&nbsp;&nbsp;Settings
      </button>
    </div>
  </div>

  <div class="row bg-light p-2">
    <div class="col-12">

      <!-- Filters -->
      <div class="row bg-white pt-2 pb-2">
        <div class="col-12">
          <app-report-filters page="coupon-report" [showCalendar]="false" [showCouponSource]="false" [showCouponSourceRetailer]="true" (filterChange)="onfilterChange($event)"></app-report-filters>
        </div>
      </div>

      <!-- Report -->
      <div class="row bg-white mt-2 pt-2 pb-2">
        <div class="col-12">

          <!-- Pagination -->
          <div class="row pagination-row mt-0 m-1">
            <div class="col-1">
              <select class="form-select form-select-sm mt-1" [(ngModel)]="customersPageSize" (change)="onPageSizeChange($event)" [disabled]="customersLoading">
                <option *ngFor="let item of pageSize" [value]="item.value">{{ item.value }}</option>
              </select>
            </div>
            <div class="col-2 label text-muted">
              <div class="mt-2">records per page</div>
            </div>
            <div class="col-9">
              <pagination-controls class="label float-end mt-1" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCustomersPageChange($event)" *ngIf="customersCount > 0"></pagination-controls>
            </div>
          </div>

          <!-- Header -->
          <div class="row customers-header-row border-bottom m-1">
            <div class="col-4 title text-muted cursor-pointer" (click)="changeSorting('coupon_title')">
              Customer Name
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="customers.length != 0 && customersSortType == 'asc' && customersSortField == 'name'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="customers.length != 0 && customersSortType == 'desc' && customersSortField == 'name'"></i-bs>
            </div>
            <div class="col-4 title text-muted cursor-pointer" (click)="changeSorting('clips_count')">
              Cash Balance
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="customers.length != 0 && customersSortType == 'asc' && customersSortField == 'cash_balance'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="customers.length != 0 && customersSortType == 'desc' && customersSortField == 'cash_balance'"></i-bs>
            </div>
            <div class="col-4 title text-muted cursor-pointer" (click)="changeSorting('redeems_count')">
              Points Balance
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="customers.length != 0 && customersSortType == 'asc' && customersSortField == 'points_balance'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="customers.length != 0 && customersSortType == 'desc' && customersSortField == 'points_balance'"></i-bs>
            </div>
          </div>

          <!-- Loader & Empty message -->
          <div class="row mt-4 mb-4">
            <div class="col-12 text-center">
              <div class="spinner-border text-info mt-4 mb-4" role="status" *ngIf="customersLoading === true"></div>

              <div class="mt-4 pt-4" *ngIf="customersLoading === false && customers.length == 0">
                <i-bs class="text-black-50 mt-4 pt-4" name="star" width="30" height="30"></i-bs>
                <div class="col-12 text-center text-black-50 mb-4 pb-4">Data not found</div>
              </div>
            </div>
          </div>

          <!-- Customers -->
          <div class="row customers-row border-bottom border-light m-1" *ngFor="let customer of customers | paginate: { itemsPerPage: customersPageSize, currentPage: customersPage, totalItems: customersCount }; let i = index;">
            <div class="col-4 value text-muted">
              {{ customer.name }}
            </div>
            <div class="col-4 value text-muted">
              {{ customer.cash_balance | number }}
            </div>
            <div class="col-4 value text-muted">
              {{ customer.points_balance | number }}
            </div>
          </div>

          <!-- Pagination -->
          <div class="row pagination-row mt-0 m-1">
            <div class="col-12">
              <pagination-controls class="label float-end mt-1" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCustomersPageChange($event)" *ngIf="customersCount > 0"></pagination-controls>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

